<template>
  <div class="con" v-loading="loading">
  <div class="text item">
    <div class="Table-Con">
    <el-form ref="ruleForm" label-width="200px" class="demo-ruleForm">
      <el-form-item :label="`${$t('lang.ConfigSetting.KeywordFilter')}：`" prop="name">
        <arraddinput :List="data.name" @GetArrList="GetArrList"></arraddinput>
      </el-form-item>
    </el-form>
    </div>
  </div>
  <el-button type="danger" size="mini" @click="updateConfig" class="Config-Buttom">
    {{$t('lang.ConfigSetting.SaveApply')}}
  </el-button>
  </div>
</template>
<script>
import arraddinput from '../../../ArrAddInput/index'
import { updateConfig, listConfig } from '@/api/configurationlist'
import { cloneDeep, isEqual } from 'lodash'
export default {
  props:["deviceDid", "deviceSn"],
  data(){
    return{
      loading:true,
      WatchData:{
        name:[]
      },
      data: {}
    }
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler: function() {
        this.getConfig()
      }
    }
  },
  components:{
    arraddinput
  },
  methods:{
    // 获取配置参数
    getConfig() {
      this.loading = true
      listConfig(this.deviceSn, this.deviceDid, [
        { section: "string", 
          config: "filter", 
          lists: [
            { list: "name" }
          ] }
      ]).then(res => {
        const data = res.data.data.mess[0];
        this.$set(this.data, "name", data.s_objects[0].lists.name);
        this.WatchData = cloneDeep(this.data)
        this.loading = false
      }).catch(err => {
        this.$message({
          message: this.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    updateConfig(){
      if(!isEqual(this.data, this.WatchData)) {
        let data={}
        //筛选为空的参数
        for(let key in this.WatchData){
          data[key]=this.WatchData[key]
        }
        updateConfig(this.deviceSn,this.deviceDid,[
          { section:"string",
            config: "filter",
            action:0,
            index:[0],
            server:'filter',
            lists:{name:data.name}
          }
        ]).then((res)=>{
          if(res.data.data.mess===0){
            //重启防护墙
            updateConfig(this.deviceSn,this.deviceDid,[
              { section:"string",
                config: "filter",
                action:0,
                index:[0],
                server:'firewall',
                lists:{name:data.name}
                }
            ]).then(res => {
              this.$message({
                  showClose: true,
                  message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
                  type: 'success'
                });
                this.getConfig()
            })    
          }else {
            this.$message({
              showClose: true,
              message: this.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });
            return
          }
        })
      }else{
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return
      } 
    },
    GetArrList(props){
      this.data.name=props
    }
  },
}
</script>
<style src='../../../common.css' scoped></style>

